import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import useStyles from './style';

const ClauseDetailsViewer = (props) => {
  const { blockState, block, config, getDocumentDataForClause } = props;
  const classes = useStyles();

  const { dataElement, dataElementLabel } = block;
  const hasData =
    blockState[dataElement] !== null &&
    blockState[dataElement] !== undefined &&
    blockState[dataElement] !== '';

  const dataModel = block.dataModel || block.config?.[0]?.dataModel;
  const documentData = getDocumentDataForClause ? getDocumentDataForClause(dataModel) : [];

  const [UI, setUI] = useState({
    title: config[0].title,
    subTitle: config[0].subTitle,
    noDataText: config[0].noDataText,
  });

  const [matchedRecords, setMatchedRecords] = useState([]);

  const findMatchingRecords = () => {
    const matches = [];
    documentData?.forEach((row, index) => {
      const matchingKey = Object.keys(row).find((key) => key.includes(dataElement));
      if (matchingKey) {
        matches.push({
          fileName: row.originalName || row.fileName || `Document ${index + 1}`,
          dataElement: dataElementLabel,
          value: row[matchingKey]?.value || row[matchingKey],
        });
      }
    });
    return matches;
  };

  const matchingRecords = findMatchingRecords();

  const countMatchingRows = () => {
    let matchCount = 0;
    documentData?.forEach((row) => {
      const hasMatch = Object.keys(row).some((key) => key.includes(dataElement));
      if (hasMatch) matchCount++;
    });
    return matchCount;
  };

  const matchingRowsCount = countMatchingRows();

  useEffect(() => {
    setMatchedRecords(matchingRecords);

    if (matchingRowsCount === 0) {
      if (props?.match?.params?.id) {
        setUI((prev) => ({
          ...prev,
          subTitle: `${dataElementLabel} Analysis`,
          noDataText: `The "${dataElementLabel}" is not present in any of the uploaded documents.`,
        }));
      } else {
        if (documentData.length > 0) {
          setUI((prev) => ({
            ...prev,
            subTitle: `${dataElementLabel} Analysis`,
            noDataText: `After analyzing ${documentData.length} documents, the "${dataElementLabel}" was not found in any of them.`,
          }));
        } else {
          setUI({
            title: config[0].title,
            subTitle: config[0].subTitle,
            noDataText: config[0].noDataText,
          });
        }
      }
    } else if (matchingRowsCount === 1) {
      setUI((prev) => ({
        ...prev,
        subTitle: `${dataElementLabel} Analysis`,
        noDataText: `Analysis complete: "${dataElementLabel}" found in 1 uploaded document.`,
      }));
    } else {
      setUI((prev) => ({
        ...prev,
        subTitle: `${dataElementLabel} Analysis`,
        noDataText: `Analysis complete: "${dataElementLabel}" found in ${matchingRowsCount} uploaded documents.`,
      }));
    }
    // NOTE: preserves your original dependency intent
  }, [matchingRecords.lengt, documentData.length]); // (kept as-is)

  return (
    <div className={classes.root}>
      <div className={classes.section}>
        <Typography className={classes.title}>{UI.title}</Typography>

        <div className={classes.infoPanel}>
          <img src={config[0].icon} className={classes.icon} alt="" />

          <div className={classes.infoTextCol}>
            <Typography className={classes.subTitle}>{UI.subTitle}</Typography>
            <Typography className={classes.noDataText}>{UI.noDataText}</Typography>

            {matchedRecords.length > 0 && (
              <div className={classes.recordsWrap}>
                {matchedRecords.map((record, index) => (
                  <div key={index} className={classes.recordItem}>
                    <Typography className={classes.recordFileName}>
                      File Name: {record.fileName}
                    </Typography>
                    <Typography className={classes.recordLabel}>
                      {record.dataElement}
                    </Typography>
                    <Typography className={classes.recordValue}>"{record.value}"</Typography>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div />
      </div>
    </div>
  );
};

export default ClauseDetailsViewer;
